import(/* webpackMode: "eager" */ "/repo/apps/cdp-web-demo/app/(main)/page.tsx");
